import {Radio} from "antd";
import {useProject} from "../../Context/ProjectContext";
import {useEffect} from "react";
import ResultHeader from "../Table/ResultHeader";
import ResultRow from "../Table/ResultRow";
import ResultHeaderCell from "../Table/ResultHeaderCell";
import ResultBody from "../Table/ResultBody";
import getSettingsItem from "./SettingsItem";
import ResultTable from "../Table/ResultTable";

export default function CalculationTolerancesSettings({onValuesChange, values, defValues}) {
    const {} = useProject()

    return (
        <>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: 300}}>Calculation</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 115}}>User Preference</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 115}}>System Default</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left', width: 230}}>Description</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        getSettingsItem({
                            value: values?.stdStepTol,
                            defaultValue: defValues?.stdStepTol,
                            onChange: (value) => {onValuesChange('stdStepTol', value)},
                            label: 'Water surface calculation tol. (.0001 - .1 ft)',
                            description: '',
                            min: 0.0001,
                            max: 0.1,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.criticalTol,
                            defaultValue: defValues?.criticalTol,
                            onChange: (value) => {onValuesChange('criticalTol', value)},
                            label: 'Critical depth calculation tol. (.0001 - .1 ft)',
                            description: '',
                            min: 0.0001,
                            max: 0.1,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.numOfStdStepTrials,
                            defaultValue: defValues?.numOfStdStepTrials,
                            onChange: (value) => {onValuesChange('numOfStdStepTrials', value)},
                            label: 'Maximum number of iterations (3 - 40)',
                            description: '',
                            min: 3,
                            max: 40,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.maxErrorTol,
                            defaultValue: defValues?.maxErrorTol,
                            onChange: (value) => {onValuesChange('maxErrorTol', value)},
                            label: 'Maximum difference tolerance (.1 - 1.0 ft)',
                            description: '',
                            min: 0.1,
                            max: 1.0,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.flowTolRatio,
                            defaultValue: defValues?.flowTolRatio,
                            onChange: (value) => {onValuesChange('flowTolRatio', value)},
                            label: 'Flow tolerance factor (.0001 - .05)',
                            description: '',
                            min: 0.0001,
                            max: 0.05,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.splitFlowNTrial,
                            defaultValue: defValues?.splitFlowNTrial,
                            onChange: (value) => {onValuesChange('splitFlowNTrial', value)},
                            label: 'Maximum iteration in Split flow (3 - 100)',
                            description: '',
                            min: 3,
                            max: 100,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.splitFlowRatio,
                            defaultValue: defValues?.splitFlowRatio,
                            onChange: (value) => {onValuesChange('splitFlowRatio', value)},
                            label: 'Flow tolerance factor in weir split flow (.0001 - .05)',
                            description: '',
                            min: 0.0001,
                            max: 0.05,
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.splitFlowTol,
                            defaultValue: defValues?.splitFlowTol,
                            onChange: (value) => {onValuesChange('splitFlowTol', value)},
                            label: 'Max difference in junction split flow (.001 - .1 ft)',
                            description: '',
                            min: 0.001,
                            max: 0.1,
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}
